var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c(
        "w-scroll-view",
        { style: { height: "100%" }, attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            { attrs: { grow: "" } },
            [
              _c(
                "w-col",
                {
                  style: { /*maxWidth:'1140px',*/ margin: "0px auto" },
                  attrs: { sm: "12" },
                },
                [
                  _vm.isOwner
                    ? [
                        !_vm.demoExpired
                          ? _c("w-tabs", {
                              attrs: { value: _vm.activeTab, tabs: _vm.tabs },
                              on: {
                                input: function ($event) {
                                  return _vm.setTab($event)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm.demoExpired
                          ? _c(
                              "div",
                              { staticClass: "demo-box" },
                              [
                                _c("w-tabs", {
                                  attrs: {
                                    value: _vm.activeTab,
                                    tabs: _vm.tabs,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.setTab($event)
                                    },
                                  },
                                }),
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("demo-expired")) + " "
                                  ),
                                ]),
                                _c("div", { staticClass: "sub-title" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$ct("demo-expired-sub")) +
                                      " "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _c(
                    "transition",
                    { attrs: { name: "fast-fade", mode: "out-in" } },
                    [_c("router-view", { key: _vm.$route.path })],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }